import { getRandomString } from './helpers'

export const openFrameStepEventName = 'Open frame step'
export const addFrameToCartEventName = 'Add frame to cart'

/**
 * Triggers an event in Google Tag Manager.
 */
export const triggerGoogleTagManagerEvent = (
  event: string,
  extraAttributes?: Record<string, any>,
) => {
  let dataLayerEvent = {
    event,
    eventId: getRandomString(),
  }

  if (extraAttributes) {
    dataLayerEvent = {
      ...dataLayerEvent,
      ...extraAttributes,
    }
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(dataLayerEvent)
}
